// CloudWatch RUM bootstrap, shared by all three apps.
//
// `addXRayTraceIdHeader` is the important part: it puts X-Amzn-Trace-Id on every
// fetch/XHR the app makes, so the browser session and the backend X-Ray trace
// are the same trace. Without it RUM and X-Ray stay two datasets that cannot be
// joined, and "which backend calls did this click cause?" stays unanswerable.
//
// Requires X-Amzn-Trace-Id in the API's CORS AllowHeaders — see the Cors block
// in projects/*/api/stack/stack.json.

let client = null;
let started = false;

export const init = ({
  applicationId,
  identityPoolId,
  region,
  applicationVersion = "1.0.0",
  sessionSampleRate = 1,
} = {}) => {
  // Unconfigured is the normal case locally and in tests — stay silent rather
  // than logging a warning on every dev page load.
  if (started || !applicationId || !identityPoolId || !region) return;
  started = true;

  // Dynamically imported so the SDK is a separate chunk that is never fetched
  // when RUM is not configured.
  import("aws-rum-web")
    .then(({ AwsRum }) => {
      client = new AwsRum(applicationId, applicationVersion, region, {
        identityPoolId,
        sessionSampleRate,
        endpoint: `https://dataplane.rum.${region}.amazonaws.com`,
        allowCookies: true,
        enableXRay: true,
        telemetries: [
          "errors",
          "performance",
          ["http", { addXRayTraceIdHeader: true }],
        ],
      });
    })
    .catch(() => {
      // A blocked or failed telemetry bundle must never take the app down.
      started = false;
    });
};

// Report a handled error that would otherwise never reach RUM, e.g. one caught
// by a React error boundary.
export const recordError = (error) => {
  if (client) {
    try {
      client.recordError(error);
    } catch (e) {
      /* ignore */
    }
  }
};
